import { Upload as AntUpload } from 'antd';
import clsx from 'clsx';
import { AntButton } from 'components/ant/AntButton/AntButton';
import { AntButtonProps } from 'components/ant/AntButton/AntButton.types';
import { Modal as UIModal } from 'components/UI/Modal/styled';
import React from 'react';

import s from './Upload.module.less';

export const Span: React.FC<React.HTMLAttributes<HTMLSpanElement>> = (props) => {
  const { className, children, ...rest } = props;

  return (
    <span {...rest} className={clsx(s.span, className)}>
      {children}
    </span>
  );
};

export const EllipsisedText: React.FC<React.HTMLAttributes<HTMLSpanElement>> = (props) => {
  const { className, children, ...rest } = props;

  return (
    <span {...rest} className={clsx(s.ellipsisedText, className)}>
      {children}
    </span>
  );
};

export const FileWrap: React.FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
  const { className, children, ...rest } = props;

  return (
    <div {...rest} className={clsx(s.fileWrap, className)}>
      {children}
    </div>
  );
};

/**
 * Note(pkocherov-xometry): https://4x.ant.design/components/upload/
 * Antd fixed their bug:
 *
 * Please note that there does exist a bug which makes an onChange
 * event still trigger even when the file is not in the list before 4.13.0.
 *
 * MIG-05: `className` MUST be forwarded so the two external `styled(UIUpload)`
 * wrappers (IncomingInvoice / PreQuote Upload/styled.ts) keep injecting their
 * `.ant-upload { margin-bottom: 0 }` override.
 */
export const Upload: React.FC<React.ComponentProps<typeof AntUpload>> = (props) => {
  const { className, children, ...rest } = props;

  return (
    <AntUpload {...rest} className={clsx(s.upload, className)}>
      {children}
    </AntUpload>
  );
};

export const UploadButton: React.FC<AntButtonProps> = (props) => {
  const { className, children, ...rest } = props;

  return (
    <AntButton {...rest} className={clsx(s.uploadButton, className)}>
      {children}
    </AntButton>
  );
};

export const Modal: React.FC<React.ComponentProps<typeof UIModal>> = (props) => {
  const { className, children, ...rest } = props;

  return (
    <UIModal {...rest} className={clsx(s.uploadModal, className)}>
      {children}
    </UIModal>
  );
};
